export default __webpack_public_path__ + "static/media/A_01_01_sound_v01.1ed8b38b.mp3";